import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoaderService } from '../shared/loader/services/loader.service';
import { HttpRespuesta } from '../models/http-respuesta.interface';
import { SupervisorRequest } from '../models/enfermera-request.interface';
import { Supervisor } from '../models/supervisor.interface';
import { TotalesSupervisor } from '../models/totales-generales.interface';
import { PendientePorAsignar } from '../models/pendiente-asignar.interface';
import { Enfermera } from '../models/enfermera.interface';
import { Medico } from '../models/medico.interface';
import { CasoClinico } from '../models/caso-clinico.interface';
import { RedimirSupervisor, SolicitudCanjeSupervisor } from '../models/redimir.interface';

const httpOptions = {
  headers: new HttpHeaders({

    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',

  })
};

@Injectable({
  providedIn: 'root'
})
export class SupervisorService {

  constructor(private httpclient: HttpClient, private loaderService: LoaderService) { }

  nuevoSupervisor(supervisor: SupervisorRequest): Observable<HttpRespuesta<Supervisor>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<Supervisor>>(environment.api.supervisores, supervisor, httpOptions).pipe(finalize(() => this.loaderService.desactivar()))
  }
  getEnfermera(id: string): Observable<HttpRespuesta<Enfermera>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<Enfermera>>(environment.api.enfermeras + '/' + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  totales(id: number): Observable<HttpRespuesta<TotalesSupervisor>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<TotalesSupervisor>>(environment.api.supervisorTotales + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()))
  }
  getSupervisor(id: number): Observable<HttpRespuesta<Supervisor>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<Supervisor>>(environment.api.supervisores + "/" + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  getPendientesPorAsignar(id: number): Observable<PendientePorAsignar[]> {
    this.loaderService.activar();
    return this.httpclient.get<PendientePorAsignar[]>(environment.api.pendientePorAsignar + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  desasociarEnfermera(id: number): Observable<HttpRespuesta<Enfermera>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<Enfermera>>(environment.api.desasignarEnfermeraSupervisor + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  asociarEnfermera(fk_supervisor: number, fk_enfermera: number): Observable<HttpRespuesta<Enfermera>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<Enfermera>>(environment.api.asignarEnfermeraSupervisor, { fk_supervisor, fk_enfermera }, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  asociarEnfermeraMedico(fk_enfermera: number, fk_medico: number): Observable<HttpRespuesta<Medico>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<Medico>>(environment.api.asigacionEnfermeraMedico, { fk_enfermera, fk_medico }, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  desasociarEnfermeraMedico(fk_enfermera: number, fk_medico: number): Observable<HttpRespuesta<Enfermera>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<Enfermera>>(environment.api.desasignarEnfermeraMedico, { fk_enfermera, fk_medico }, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  asociarEnfermeraCasoClinico(fk_enfermera: number, fk_casoclinico: number): Observable<HttpRespuesta<CasoClinico>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<CasoClinico>>(environment.api.asigacionEnfermeraCasoClinico, { fk_enfermera, fk_casoclinico }, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  getCatalogoEnfermeras(id: number): Observable<HttpRespuesta<Enfermera[]>> {
    return this.httpclient.get<HttpRespuesta<Enfermera[]>>(environment.api.catalogoEnfermeraparaSupervisor + id.toString(), httpOptions);
  }
  getCatalogoMedicos(): Observable<HttpRespuesta<Medico[]>> {
    return this.httpclient.get<HttpRespuesta<Medico[]>>(environment.api.catalogoMedicoparaSupervisor, httpOptions);
  }
  getCatalogoEnfermerasXAsignarCC(idMedico: number, idSupervisor: number): Observable<HttpRespuesta<Enfermera[]>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<Enfermera[]>>(environment.api.catalogoEnfermerasparaAsignacionCC + idMedico.toString() + "/" + idSupervisor.toString(), httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  getSupervisorPreSolicitud(id: number): Observable<HttpRespuesta<Supervisor>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<Supervisor>>(environment.api.presolicitudCanjeSupervisor + "/" + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setSolicitudCanje(canje: SolicitudCanjeSupervisor): Observable<HttpRespuesta<RedimirSupervisor>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirSupervisor>>(environment.api.solicitudCanjeSupervisor, canje, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
}
